import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import moment from 'moment';
import {
  AddIconButton,
  DeleteIconButton,
  RemoveIconButton,
} from '../../../../components/common/button/CustomIconButton';
import { Checkbox, Grid } from '@mui/material';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
interface IProps {
  item: any;
  isView: any;
  handleDelete: any;
  index: number;
  setPartIdx: React.Dispatch<React.SetStateAction<number>>;
  setIsOpenPopup: React.Dispatch<React.SetStateAction<boolean>>;
  defects: any;
  processes: any;
}

const TBodyRow = ({
  item,
  index,
  isView,
  handleDelete,
  setPartIdx,
  setIsOpenPopup,
  defects,
  processes,
}: IProps) => {
  const [rowRender, setRowRender] = useState(false);

  const handleChange = (e: any) => {
    item[e.target.name] = e.target.value;
    setRowRender((prev: any) => !prev);
  };

  return (
    <>
      <tr>
        <td>{index + 1}</td>
        <td style={{ textAlign: 'center', minWidth: '160px' }}>
          <DatePickerMui
            label=""
            onChange={(date) => {
              item.date = moment(date || null);
              setRowRender((prev: any) => !prev);
            }}
            value={(item?.date && moment(item?.date)) || null}
          />
        </td>
        <td style={{ minWidth: '250px' }}>
          {isView ? (
            item?.part_id && item.part_id?.part_number
          ) : (
            <Grid container xs={12} direction="row" alignItems={'center'}>
              <Grid item xs={10}>
                <p
                  style={{
                    fontSize: '1.2rem',
                  }}
                >
                  {typeof item?.part_id === 'object' && item?.part_id !== null
                    ? item.part_id?.part_number
                    : item?.partNumber}
                  {!item?.part_id && 'Pick Part No.'}
                </p>
              </Grid>

              {item.part_id ? (
                <Grid item xs={2}>
                  <RemoveIconButton
                    tooltipTitle="remove part"
                    onClick={() => {
                      item.part_id = null;
                      item.partNumber = null;
                      item.partName = null;
                      item.customerName = null;
                      setRowRender((prev: any) => !prev);
                    }}
                  />
                </Grid>
              ) : (
                <Grid item xs={2}>
                  <AddIconButton
                    tooltipTitle="add part"
                    onClick={() => {
                      setIsOpenPopup(true);
                      setPartIdx(index);
                    }}
                  />
                </Grid>
              )}
            </Grid>
          )}
        </td>
        <td style={{ textAlign: 'center', minWidth: '120px', width: '120px' }}>
          <TableInput
            isView={isView}
            type="number"
            name="rej_qty"
            value={item?.rej_qty ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center', width: '200px', minWidth: '200px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="resp"
            value={item?.resp ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td>
          <AutocompleteMuiCustom
            id="Process"
            label=""
            option_name="process_name"
            arrayofObj={processes}
            value={item.process_id || ''}
            onChange={(e, value) => {
              item.process_id = value;
              setRowRender((prev: any) => !prev);
            }}
            sx={{ width: 200, margin: 2 }}
          />
        </td>
        <td>
          <AutocompleteMuiCustom
            id="Defect"
            label=""
            option_name="defect_name"
            arrayofObj={defects}
            value={item.defect_id || ''}
            onChange={(e, value) => {
              item.defect_id = value;
              setRowRender((prev: any) => !prev);
            }}
            sx={{ width: 200, margin: 2 }}
          />
        </td>
        <td style={{ textAlign: 'center', width: '200px', minWidth: '200px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="containment_action"
            value={item?.containment_action ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center', width: '150px', minWidth: '150px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="rework_scrap"
            value={item?.rework_scrap ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center', minWidth: '120px', width: '120px' }}>
          <TableInput
            isView={isView}
            type="number"
            name="time_min"
            value={item?.time_min ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center', width: '150px', minWidth: '150px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="rework_and_checkby"
            value={item?.rework_and_checkby ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        {['ok', 'not ok'].map((value) => (
          <td>
            <Checkbox
              checked={item?.reinspection === value}
              onChange={() => {
                item.reinspection = value;
                setRowRender((prev) => !prev);
              }}
            />
          </td>
        ))}
        <td style={{ textAlign: 'center', width: '150px', minWidth: '150px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="checked_by_qc"
            value={item?.checked_by_qc ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center', width: '150px', minWidth: '150px' }}>
          <TableInput
            isView={isView}
            type="text"
            name="checked_by_qa_head"
            value={item?.checked_by_qa_head ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        <td style={{ textAlign: 'center' }}>
          <TableInput
            isView={isView}
            type="text"
            name="remarks"
            value={item?.remarks ?? null}
            onChange={(e) => {
              handleChange(e);
            }}
          />
        </td>
        {!isView && (
          <td style={{ textAlign: 'center' }}>
            <DeleteIconButton
              tooltipTitle="DELETE"
              onClick={() => {
                handleDelete(item?._id, index);
              }}
            />
          </td>
        )}
      </tr>
    </>
  );
};

export default TBodyRow;
